
import React, { ReactNode, createContext, useReducer } from 'react';
import { LanguageActions, languageReducer } from './reducers/language.reducer';
import { StatusActions, statusReducer } from './reducers/status.reducer';
import { SearchActions, searchReducer } from './reducers/search.reducer';
import { AutocompleteActions, autocompleteReducer } from './reducers/autocomplete.reducer';
import { ResultsActions, resultsReducer } from './reducers/results.reducer';
import { SuggestionsActions, suggestionsReducer } from './reducers/suggestions.reducer';
import { ContextType } from './types/context.type';
import { HighlightActions, highlightReducer } from './reducers/highlight.reducer';

const initialAppData: any = { status: "not-started" };

const AppContext = createContext<ContextType>({
  state: initialAppData,
  dispatch: () => null
});

const mainReducer = (
  { language, status, search, autocomplete, results, suggestions, highlight }: any,
  action: StatusActions | SearchActions | AutocompleteActions | ResultsActions | SuggestionsActions | LanguageActions | HighlightActions
) => ({
  language: languageReducer(language, action),
  status: statusReducer(status, action),
  search: searchReducer(search, action),
  autocomplete: autocompleteReducer(autocomplete, action),
  results: resultsReducer(results, action),
  suggestions: suggestionsReducer(suggestions, action),
  highlight: highlightReducer(highlight, action)
});

const AppProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const [state, dispatch] = useReducer(mainReducer, initialAppData);
  return (
    <AppContext.Provider value={{state, dispatch}}>
      {children}
    </AppContext.Provider>
  )
}

export { AppContext, AppProvider };
